import { useEffect, useMemo } from 'react';
import { SettingClient, updateClientMetaPixel } from '../../helpers/client';
import { trackersRunner } from '../trackersRunner';
import { MetaPixelTracker } from './metaPixelTracker';

function loadMetaPixel(pixelId: string): void {
  // Meta Pixel base code
  const n: any = (window.fbq = function (...args: any[]) {
    if (n.callMethod) {
      n.callMethod(...args);
    } else {
      n.queue.push(args);
    }
  });

  if (!window._fbq) {
    window._fbq = n;
  }

  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];

  const script = document.createElement('script');
  script.id = 'meta-pixel-js';
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  script.onload = () => {
    updateClientMetaPixel();
    const tracker = new MetaPixelTracker();
    trackersRunner.register(tracker);
    tracker.trackPage();
  };
  document.head.appendChild(script);

  try {
    window.fbq('init', pixelId);
  } catch {
    console.error('Not possible to init metapixel.');
  }
}

export function MetaPixelScript(): React.JSX.Element | null {
  const settingsClient: SettingClient = useMemo(() => new SettingClient(), []);

  useEffect(() => {
    if (document.getElementById('meta-pixel-js')) {
      return;
    }

    settingsClient
      .get()
      .then((settings) => {
        const pixelId = settings?.metaPixelId;
        if (!pixelId) {
          return;
        }

        loadMetaPixel(pixelId);
      })
      .catch((exception) => {
        console.error('Not possible to load settings', exception);
      });
  }, [settingsClient]);

  return null;
}
